// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"746ed015","193":"c833ca86","225":"d043d159","408":"42d55bca"}[chunkId] + ".chunk.js";
};